export const REGEX = {
    username: {
        regexr: /^[A-Za-z0-9]{4,10}$/, // 최소 4자리로 넉넉하게
        text: "영문자, 숫자 4 ~ 10자리 형식이어야 합니다"
    },
    password: {
        regexr: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{7,128}$/,
        text: "하나의 영문자, 숫자, 특수문자를 포함한 7 ~ 128자리 형식이어야 합니다"
    },
    email: {
        regexr: /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*\.[a-zA-Z]{1,63}$/, 
        text: "이메일 형식이어야 합니다"
    },
    name: {
        regexr: /^[가-힣]{1,}$/, // 
        text: "한글문자 형식이어야 합니다"
    },
    nickname: {
        regexr: /^(?=.*[a-z0-9가-힣])[a-z0-9가-힣]{2,16}$/,
        text: "2자 이상 16자 이하, 영어 또는 숫자 또는 한글 형식이어야 합니다."
    },
    phone: {
        regexr: /^01([0|1|6|7|8|9])([0-9]{4})([0-9]{4})+$/,
        text: "ex) 01012345678 형식이어야 합니다."
    },
};